<template>
    <div v-on-clickaway="away">
        <div class="colour-picker">
            <a href="#" 
                class="colour-picker__toggle"
                @click.prevent="toggleDropdown()">

                <span class="colour-picker__display" 
                    v-bind:style="{ backgroundColor: tracked_colour.hex }"></span>

                <span class="align-middle">
                    {{ name }}
                </span>
            </a>

            <div v-show="show_dropdown" class="dropdown">
                <colour-picker v-model="tracked_colour"></colour-picker>
            </div>
        </div>
    </div>
</template>

<script>
    import { Chrome as ColourPicker } from 'vue-color';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        components: {
            ColourPicker
        },

        mixins: [
            clickaway
        ],

        props: ['name', 'colour'],

        data() {
            return {
                show_dropdown: false,
                tracked_colour: {
                    hex: '#ffffff'
                }
            }
        },

        watch: {
            tracked_colour() {
                this.$emit("colour-picked", this.tracked_colour.hex);
            },

            colour(colour) {
                this.tracked_colour.hex = colour;
            }
        },

        methods: {
            toggleDropdown() {
                this.show_dropdown = !this.show_dropdown;
            },

            away() {
                this.show_dropdown = false;
            }
        },

        created() {
            this.tracked_colour.hex = this.colour;
        }
    }
</script>

<style scoped lang="scss">
    .colour-picker {
        position: relative;

        &__toggle {
            display: inline-block;
            color: black;
            text-decoration: none;

            span {
                vertical-align: middle;
            }
        }

        &__display {
            width: 30px;
            height: 30px;
            border: 1px solid rgba(black, 0.3);
            display: inline-block;
            margin-right: 4px;
            border-radius: 20px;
        }
    }

    .dropdown {
        position: absolute;
        top: 35px;
        z-index: 9;
    }

    .vc-chrome {
        width: 250px;
    }
</style>